import storage from '@/storage'
import { parseJwt } from '@/helpers'

import moment from 'moment'

import Authservice from '@/services/auth'

export default {
    // switchI18n({ commit }, context) {
    //     commit(types.SET_LANGUAGE, context)
    // },
    // switchSimpleServiceNames({ commit }, context) {
    //     commit(types.SET_SIMPLESERVICENAME, context)
    // },
    // switchChat({ commit }, context) {
    //     commit(types.SET_CHAT, context)
    // },

    initialize: ({ dispatch, commit, getters }) => {
        return new Promise((resolve, reject) => {
            let token = storage.get('token')

            // console.log('CheckToken', token)

            // Reject the check if token is not found
            if (!token) {
                reject('Token not found')
                return null
            }

            // Set token from storage
            commit('setToken', token)

            if (!getters.user) {
                dispatch('fetchUser', true)
                    .then(user => {
                        resolve(user)
                        commit('setUser', user)
                    })
                    .catch(err => {
                        reject(err)
                    })
            } else {
                resolve(getters.user)
                commit('setUser', getters.user)
            }
        })
    },

    // eslint-disable-next-line
    fetchUser: ({ dispatch, commit, state, getters }) => {
        return new Promise((resolve, reject) => {
            // Instantly reject if no token found
            if (!state.token) {
                return reject('No token found')
            }

            // Load user from storage
            let storageUser = storage.get('user')

            if (storageUser) {
                resolve(storageUser)
            }
        })
    },

    logout: ({ commit }) => {
        commit('setToken', null)
        commit('setUser', null)
    },

    loginWithMsal: ({ commit }, payload) => {
        let token = payload
        let access_token = token.accessToken

        commit('setLoading', true)

        return new Promise((resolve, reject) => {
            Authservice.logonWithMsalAccessToken(access_token)
                // Todo: DRY! Duplicate code.
                .then(({ user, token }) => {
                    commit('setToken', token)
                    commit('setUser', user)
                    resolve(user)
                })
                .catch(err => {
                    commit('setError', err)
                    reject(err)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        })
    },

    loginWithUserNameAndPassword: ({ commit }, payload) => {
        let { username, password } = payload

        commit('setLoading', true)

        return new Promise((resolve, reject) => {
            Authservice.logonWithUsernameAndPassword(username, password)
                .then(({ user, token }) => {
                    commit('setToken', token)
                    commit('setUser', user)
                    resolve(user)
                })
                .catch(err => {
                    commit('setError', err)
                    reject(err)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        })
    },

    impersonate: ({ commit, state, getters }, user_id) => {
        // Reject if user_id argument is missing
        if (!user_id) {
            return Promise.reject('Missing argument "user_id"')
        }

        // Reject if trying to impersonate own yourself
        if (user_id == getters.user.id) {
            return Promise.reject('Cannot impersonate yourself')
        }

        commit('setError', null)
        commit('setLoading', true)

        return Authservice.getImpersonationToken(state.token, user_id)
            .then(({ user, token }) => {
                commit('setToken', token)
                commit('setUser', user)
                Promise.resolve(user)
            })
            .catch(err => {
                commit('setError', err)
                Promise.reject(err)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    // eslint-disable-next-line
    stopImpersonation: ({ commit, state, getters }) => {
        if (!getters.isImpersonated) {
            return Promise.reject('The user is not impersonating anyone')
        }

        let token = getters.isImpersonated

        commit('setLoading', true)
        commit('setToken', token)

        return Authservice.getUserFromToken(token)
            .then(user => {
                // console.log('SetUser', user)
                commit('setUser', user)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    checklogin: ({ dispatch, commit, state, getters }) => {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            let tokenExists = !!state.token

            if (!tokenExists) {
                dispatch('logout')
                reject('Token does not exist')
            }

            if (getters.isImpersonated) {
                resolve("Can't refresh token when impersonating")
            }

            let jwt = parseJwt(state.token)
            let exp = jwt.exp_date.date
            let minutesLeftOnToken = moment()
                .utc()
                .diff(moment.utc(exp), 'minutes')
            if (minutesLeftOnToken > -5 && minutesLeftOnToken <= 0) {
                // console.log(
                //     'Refreshing token since it has less than 5 min left.'
                // )
                dispatch('refreshToken')
                resolve('Refreshed token!')
            }

            let authState = minutesLeftOnToken <= 0 ? true : false

            if (!authState) {
                dispatch('logout')
                reject('Token expired')
            }

            resolve('Everything seems ok...')
            commit('setLoading', false)
        })
    },

    // getTimeLeftOnToken: ({ state }) => {
    //     return new Promise(resolve => {
    //         let jwt = parseJwt(state.token)
    //         let exp = jwt.exp_date.date
    //         let minutesLeftOnToken = moment()
    //             .utc()
    //             .diff(moment.utc(exp), 'seconds')
    //         resolve(minutesLeftOnToken)
    //     })
    // },

    // refreshToken: ({ commit, state }) => {
    //     let http = Http()

    //     if (state.loading) {
    //         return
    //     }

    //     // Set loading to true
    //     commit('LOADING', true)

    //     http.post(auth_url + '/refreshToken', {
    //         token: state.token,
    //     })
    //         .then(response => response.data)
    //         .then(data => {
    //             // console.log('token refreshed')
    //             commit('AUTH_SUCCESS', {
    //                 token: data.token,
    //                 user: data.user,
    //             })

    //             storage.session.set('token', data.token)
    //             storage.session.set('user', data.user)
    //         })
    //         .catch(error => {
    //             console.error('refreshToken failed', error)
    //         })
    //         .finally(() => {
    //             commit('LOADING', false)
    //         })
    // },

    // AUTH_REQUEST: ({ commit, dispatch }, payload) => {
    //     let data = payload.data

    //     return new Promise((resolve, reject) => {
    //         axios({
    //             url: auth_url + '/password',
    //             data: data,
    //             method: 'POST',
    //         })
    //             .then(resp => {
    //                 const token = resp.data.token
    //                 const user = resp.data.user
    //                 // console.log('authreq.token ' + token)
    //                 if (token && user) {
    //                     storage.session.set('token', token)
    //                     storage.session.set('user', JSON.stringify(user))

    //                     commit('AUTH_SUCCESS', {
    //                         token: token,
    //                         user: user,
    //                     })
    //                     resolve(resp)
    //                 } else {
    //                     reject('token or user not defined')
    //                 }
    //             })
    //             .catch(err => {
    //                 commit('AUTH_ERROR')
    //                 storage.remove('token')
    //                 storage.remove('user')
    //                 reject(err)
    //             })
    //     })
    // },

    // AUTH_LOGOUT: ({ commit, dispatch }) => {
    //     return new Promise((resolve, reject) => {
    //         commit('AUTH_LOGOUT')
    //         storage.remove('token')
    //         storage.remove('user')
    //         resolve()
    //     })
    // },
}
